import { useEffect, useState } from "react";
import close from '../../theme/img/close-cross.svg';

const CustomPopup = (props) => {
  const [show, setShow] = useState(false);

  const closeHandler = (e) => {
    setShow(false);
    props.onClose(false);
  };

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  return (
    <div
      style={{
        visibility: show ? "visible" : "hidden",
        opacity: show ? "1" : "0"
      }}
      className="popup-overlay"
    >
      <div className="popup-main">
        <h2>{props.title}</h2>
        <span className="popup-close" onClick={closeHandler}>
          &times;
        </span>
        <div className="popup-content">{props.children}</div>
      </div>
    </div>
  );
};

export default CustomPopup;